// Modules
import cn from 'classnames';

// Types
import type { TButtonProps } from './Button.type';

// Styles
import styles from './styles/styles.module.scss';

// Components
import Spinner from '../Spinner';

// Constants
import { BUTTON_DEFAULT_PROPS, BUTTON_LOADING_ICON_POSITION } from './Button.constant';

const Button = (props: TButtonProps) => {
  const {
    block,
    children,
    className,
    color = BUTTON_DEFAULT_PROPS.color,
    disabled,
    isLoading,
    loadingClassName,
    loadingIconPosition = BUTTON_DEFAULT_PROPS.loadingIconPosition,
    loadingText,
    loadingTextClassName,
    size = BUTTON_DEFAULT_PROPS.size,
    variant = BUTTON_DEFAULT_PROPS.variant,
    ...restProps
  } = props;

  const buttonCN = cn(styles.legion_button, className, styles[size!], styles[variant!], {
    [styles.block]: block,
    [styles.disabled]: disabled,
    [styles.loading]: isLoading,
    [styles[color!]]: !disabled,
    [styles['loading_right']]: loadingIconPosition === BUTTON_LOADING_ICON_POSITION.right
  });
  const loadingIconCN = cn(styles.loading_spinner, loadingClassName);
  const loadingTextCN = cn(styles.loading_text, loadingTextClassName);

  return (
    <button className={buttonCN} disabled={disabled || isLoading} {...restProps}>
      {isLoading ? (
        <>
          <Spinner
            className={loadingIconCN}
            trackClassName={styles.loading_spinner_track}
            indicatorClassName={styles.loading_spinner_indicator}
          />
          {loadingText && (<span className={loadingTextCN}>{loadingText}</span>)}
        </>
      ) : (
        children
      )}
    </button>
  );
};

export default Button;
